import { Tag } from '../../../../components/Toolkit/Tags/Tag';

function HistoryCheckTag() {
  return (
    <Tag text="History Checked" textColor="GREY_DARK" bgColor="GREY_LIGHTER" />
  );
}

export { HistoryCheckTag };
